import React from 'react'
import type { Props as restProps } from '@yy/one-icon'
import { Easystore, OneShip, Shopify, Shopline, WooCommerce, Wix } from '@yy/one-icon'
import { PLATFORM_APP_NAME, PLATFORM_KEYS } from '@/constant'
import { imgURL } from '@/utils/countryVersion'

export const KEYS = PLATFORM_KEYS
export const APP_NAME = PLATFORM_APP_NAME

export type IAppId = 'SL101' | 'ONE01' | 'SPF01' | 'WOC01' | 'SL201' | 'SALES01' | 'EZS01' | 'WIX01'

interface PlatformAvatarProps {
  appId?: IAppId
}

export const booleanMap = (appId: string) => {
  return {
    shopline: appId === KEYS.shopline,
    shopify: appId === KEYS.shopify,
    oneship: appId === KEYS.oneship,
    woocommerce: appId === KEYS.woocommerce,
    shopline2: appId === KEYS.shopline2,
    easystore: appId === KEYS.easystore,
  }
}

export const picUrl = {
  [KEYS.shopline]: Shopline,
  [KEYS.shopline2]: Shopline,
  [KEYS.oneship]: imgURL('./images/platformIcon/oneship.svg') || OneShip,
  [KEYS.shopify]: Shopify,
  [KEYS.woocommerce]: WooCommerce,
  [KEYS.easystore]: Easystore,
  [KEYS.wix]: Wix,
}

//支持设置拉取状态的平台
export const status_settings = [KEYS.shopline, KEYS.woocommerce]

//支持订单状态同步设置的平台
export const order_status_sync = [KEYS.shopline, KEYS.woocommerce]

// 支持订单同步邮件的平台
export const order_sync_email = [KEYS.shopline]

const PlatformAvatar: React.FC<PlatformAvatarProps & Partial<restProps>> = (prop) => {
  const { appId = 'SL101', ...restProps } = prop
  const Platform = picUrl[appId] || picUrl['ONE01']
  if (!appId || !Platform) {
    return null
  }

  if (typeof Platform === 'string') {
    return <img src={Platform} {...(restProps as any)} />
  }

  return <Platform {...restProps} origin></Platform>
}

PlatformAvatar.displayName = 'PlatformAvatar'
export default PlatformAvatar
